import type { InputType } from 'config/input.type.constants'

export const emailType: any = {
  has_email: 'has email',
  no_email: 'does not have email',
}

export const defaultInputs = (): Record<string, InputType> => {
  return {
    email: {
      title: 'Email',
      inputType: 'select',
      hasDefaultOption: true,
      options: emailType,
    },
  }
}
